/**
 * Created by Lenovo on 2017/6/28.
 */
import React, {
    Component,
    PropTypes
}from 'react';
import {Link,hashHistory} from 'react-router'
import Tip from 'COMPONENT/tip'
import FormInput from 'CONFIG/component/form/formInput'
import {alertTip, resultTip, errorShow, errToSuc,successShow} from 'UTIL/common'
import {language} from 'UTIL/common'
import BoxHeaderCreate from 'CONFIG/component/boxHeaderCreate'
import {getNowFormatDate} from 'CONFIG/function'
import  {bumpUrl}from 'CONFIG/path.config'
import FormInputSimple from "../component/form/formInputSimple";
export default class AddTOA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msg:'固件上传',
        }
    }
    submit() {
        errToSuc();
        var  ids = ['name','openId','productId','version','type','info'];
        var arr = {};
        for(let i in ids){
           arr[ids[i]] = $.trim($("#"+ids[i]).val());
        }
        console.log(arr)
        for(let i in ids){
            if(arr[ids[i]] == ''&& ids[i]!='info'){
                errorShow(ids[i]);
            }
        }
        if($("#upfile").val() == ''){
            errorShow('upfile','固件未上传！');
        }
        var pattern = /^\d+(\.\d+){0,2}$/;
        if (!pattern.test(arr.version)&&$.trim($("#version").val())!='') {
            errorShow('version','版本号输入不正确(例如1.0.1或1.0)！');
        }
        if(document.getElementById("upfile").files.length>0){
            var fileSize =  document.getElementById("upfile").files[0].size;
            if(fileSize>1024*1024){
                $("#error_msg").text("文件大小应在1M以内!");
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
                return ;

            }
        }

        if($("[name='error']").length == 0) {

            var url = arr['info'] == ''?'name='+arr.name+'&openId='+arr.openId+'&deviceNo='+arr.deviceNo+'&productId='+arr.productId
                +'&version='+arr.version+'&type='+arr.type+'&dvcModel='+arr.dvcModel:
                'name='+arr.name+'&openId='+arr.openId+'&deviceNo='+arr.deviceNo+'&productId='+arr.productId
                +'&version='+arr.version+'&type='+arr.type+'&dvcModel='+arr.dvcModel+'&info='+arr.info;
            console.log(bumpUrl+'/firmwares?'+url)
            let _this = this;
            $("#uploadForm").ajaxSubmit({
                url: bumpUrl+'/firmwares?'+url,
                type: "POST", /*设置表单以post方法提交*/
                dataType: 'JSON',
                success: function (data) {
                    console.log(data)
                    if (data.id) {
                        $("#success_msg").text('设置成功');
                        $("#success_tip").removeClass("hidden");
                        $("#success_tip").focus();
                        setTimeout(function () {
                            $("#success_tip").addClass("hidden");
                            hashHistory.push('/ota/otaIndex')
                        }, 3000);
                    } else {
                        $("#error_msg").text(data.msg);
                        $("#error_tip").removeClass("hidden");
                        $("#error_tip").focus();
                        setTimeout(function () {
                            $("#error_tip").addClass("hidden");
                        }, 3000);
                    }
                },
                error: function (error) {
                    console.log(error);
                },

            });
        }
    }
    upfile(){
        if($("#upfile").val() == ''){
            errorShow('upfile','固件未上传！');
        }else {
            successShow('upfile');
        }
    }
    render() {
        return <div>
            <section className="content-header">
                <h1> {language()['OTAManagement']}
                    <small>{language()['OTAAdd']}</small>
                </h1>
            </section>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <BoxHeaderCreate name={language()['OTAAdd']}/>
                    <div className="box-body">
                        <Tip ids=""/>
                        <div>
                            <form className="form-horizontal" role="form" id="form">
                                <FormInput name="versionName" id="name"/>
                                <FormInput name="openID" id="openId"/>
                                <FormInput name="productID" id="productId"/>
                                <FormInput name="SoftwareType" id="type" onKeyUp='4'/>
                                <FormInput name="versionNumber" id="version"/>
                                <div className="form-group ">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['firmwareUpload']}</label>
                                    <div className="col-xs-3">
                                        <form id="uploadForm">
                                            <input type="file" id="upfile"  name="file"  onChange={this.upfile.bind(this)}
                                                   multiple/>
                                        </form>
                                    </div>
                                    <span className = "">
                                          <span id={"error_upfile"}  name="success" ></span>
                                          <span className = ""></span>
                                    </span>
                                    <p className="form-control-static text-danger">
                                        <span style={{fontSize: "20px"}}>*</span>
                                    </p>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['remark']}</label>
                                    <div className="col-xs-3">
                                    <textarea type="text" className="form-control" id="info"
                                              placeholder={language()['remark']}/>
                                    </div>
                                </div>
                            </form>
                            <div className="row form-group">
                                <div className="col-xs-2 text-center">
                                </div>
                                <div className="col-xs-1 text-center">
                                    <button id="btnSubmit" className="btn btn-success"
                                            onClick={this.submit.bind(this)}>{language()['submit']}</button>
                                </div>
                                <div className="col-xs-1 text-center">
                                    <Link to="/ota/otaIndex" className="btn btn-default">{language()['return']}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/ota/addOTA.js